import React from 'react';
import { PackageIcon, TruckIcon, CheckCircleIcon, ClipboardCheckIcon, CalendarIcon, MapPinIcon, FileTextIcon, KeyIcon, UserIcon } from 'lucide-react';
// Mock delivery data
const deliveries = [{
  id: 'DHL-39485723',
  type: 'Document',
  status: 'In Transit',
  origin: 'Lagos, Nigeria',
  destination: 'London, UK',
  eta: 'May 15, 2023',
  description: 'Property Deed and Transfer Documents',
  updates: [{
    date: 'May 10, 2023',
    time: '10:30 AM',
    status: 'Package received',
    location: 'Lagos, Nigeria'
  }, {
    date: 'May 11, 2023',
    time: '2:45 PM',
    status: 'Package processed',
    location: 'Lagos, Nigeria'
  }, {
    date: 'May 12, 2023',
    time: '8:15 AM',
    status: 'Package departed',
    location: 'Lagos, Nigeria'
  }, {
    date: 'May 13, 2023',
    time: '3:20 PM',
    status: 'In transit',
    location: 'Accra, Ghana'
  }],
  courier: {
    name: 'DHL Express',
    contact: '+234 701 234 5678',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/DHL_Logo.svg/200px-DHL_Logo.svg.png'
  }
}, {
  id: 'FDX-87654321',
  type: 'Key',
  status: 'Delivered',
  origin: 'Abuja, Nigeria',
  destination: 'Toronto, Canada',
  eta: 'Delivered on April 28, 2023',
  description: 'Property Keys and Access Cards',
  updates: [{
    date: 'April 22, 2023',
    time: '9:15 AM',
    status: 'Package received',
    location: 'Abuja, Nigeria'
  }, {
    date: 'April 23, 2023',
    time: '11:30 AM',
    status: 'Package processed',
    location: 'Abuja, Nigeria'
  }, {
    date: 'April 24, 2023',
    time: '7:45 AM',
    status: 'Package departed',
    location: 'Abuja, Nigeria'
  }, {
    date: 'April 26, 2023',
    time: '2:10 PM',
    status: 'In transit',
    location: 'London, UK'
  }, {
    date: 'April 27, 2023',
    time: '10:30 AM',
    status: 'Arrived at destination',
    location: 'Toronto, Canada'
  }, {
    date: 'April 28, 2023',
    time: '11:45 AM',
    status: 'Delivered',
    location: 'Toronto, Canada'
  }],
  courier: {
    name: 'FedEx',
    contact: '+234 802 345 6789',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/FedEx_Express.svg/200px-FedEx_Express.svg.png'
  }
}];
const TrackDelivery = () => {
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-1809">
      <div className="container mx-auto px-4 py-8" data-id="element-1810">
        <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-1811">
          Track Deliveries
        </h1>
        {/* Track New Delivery */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-8" data-id="element-1812">
          <h2 className="text-xl font-bold mb-4" data-id="element-1813">Track a Delivery</h2>
          <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4" data-id="element-1814">
            <div className="flex-grow" data-id="element-1815">
              <input type="text" placeholder="Enter tracking number" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1816" />
            </div>
            <button className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition flex items-center justify-center" data-id="element-1817">
              <PackageIcon size={20} className="mr-2" data-id="element-1818" />
              Track
            </button>
          </div>
        </div>
        {/* Active Deliveries */}
        <div className="mb-8" data-id="element-1819">
          <h2 className="text-xl font-bold mb-4" data-id="element-1820">Your Active Deliveries</h2>
          <div className="space-y-6" data-id="element-1821">
            {deliveries.map(delivery => <div key={delivery.id} className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-1822">
                {/* Delivery Header */}
                <div className="bg-gray-50 p-4 border-b" data-id="element-1823">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-1824">
                    <div className="flex items-center mb-3 md:mb-0" data-id="element-1825">
                      {delivery.type === 'Document' ? <FileTextIcon size={24} className="text-blue-600 mr-3" data-id="element-1826" /> : <KeyIcon size={24} className="text-orange-600 mr-3" data-id="element-1827" />}
                      <div data-id="element-1828">
                        <h3 className="font-bold" data-id="element-1829">{delivery.description}</h3>
                        <p className="text-sm text-gray-600" data-id="element-1830">
                          Tracking ID: {delivery.id}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-1831">
                      <div className={`px-3 py-1 rounded-full text-sm font-medium ${delivery.status === 'Delivered' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-1832">
                        {delivery.status}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Delivery Details */}
                <div className="p-4" data-id="element-1833">
                  <div className="flex flex-col md:flex-row" data-id="element-1834">
                    {/* Left Column */}
                    <div className="md:w-1/2 md:pr-6 mb-6 md:mb-0" data-id="element-1835">
                      <div className="flex justify-between mb-6" data-id="element-1836">
                        <div data-id="element-1837">
                          <p className="text-sm text-gray-600 mb-1" data-id="element-1838">From</p>
                          <div className="flex items-center" data-id="element-1839">
                            <MapPinIcon size={16} className="mr-1 text-gray-600" data-id="element-1840" />
                            <span className="font-medium" data-id="element-1841">
                              {delivery.origin}
                            </span>
                          </div>
                        </div>
                        <div className="flex-grow mx-4 border-t border-dashed border-gray-300 self-center" data-id="element-1842"></div>
                        <div className="text-right" data-id="element-1843">
                          <p className="text-sm text-gray-600 mb-1" data-id="element-1844">To</p>
                          <div className="flex items-center justify-end" data-id="element-1845">
                            <MapPinIcon size={16} className="mr-1 text-gray-600" data-id="element-1846" />
                            <span className="font-medium" data-id="element-1847">
                              {delivery.destination}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center mb-4" data-id="element-1848">
                        <CalendarIcon size={16} className="mr-2 text-gray-600" data-id="element-1849" />
                        <div data-id="element-1850">
                          <p className="text-sm text-gray-600" data-id="element-1851">
                            Estimated Delivery
                          </p>
                          <p className="font-medium" data-id="element-1852">{delivery.eta}</p>
                        </div>
                      </div>
                      <div className="flex items-center" data-id="element-1853">
                        <TruckIcon size={16} className="mr-2 text-gray-600" data-id="element-1854" />
                        <div data-id="element-1855">
                          <p className="text-sm text-gray-600" data-id="element-1856">Courier</p>
                          <div className="flex items-center" data-id="element-1857">
                            <img src={delivery.courier.image} alt={delivery.courier.name} className="h-6 mr-2" data-id="element-1858" />
                            <p className="font-medium" data-id="element-1859">
                              {delivery.courier.name}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Right Column - Tracking Timeline */}
                    <div className="md:w-1/2 md:pl-6 md:border-l" data-id="element-1860">
                      <h3 className="font-bold mb-4" data-id="element-1861">Tracking Updates</h3>
                      <div className="space-y-4" data-id="element-1862">
                        {delivery.updates.map((update, index) => <div key={index} className="flex" data-id="element-1863">
                            <div className="mr-3" data-id="element-1864">
                              <div className={`w-4 h-4 rounded-full ${index === 0 ? 'bg-green-600' : 'bg-gray-300'}`} data-id="element-1865"></div>
                              {index < delivery.updates.length - 1 && <div className="h-full w-0.5 bg-gray-300 mx-auto mt-1" data-id="element-1866"></div>}
                            </div>
                            <div className="flex-grow pb-4" data-id="element-1867">
                              <div className="flex justify-between text-sm" data-id="element-1868">
                                <p className="font-medium" data-id="element-1869">{update.status}</p>
                                <p className="text-gray-600" data-id="element-1870">
                                  {update.date}, {update.time}
                                </p>
                              </div>
                              <p className="text-gray-600 text-sm" data-id="element-1871">
                                {update.location}
                              </p>
                            </div>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Delivery Footer */}
                <div className="bg-gray-50 p-4 border-t flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-1872">
                  <div className="flex items-center mb-3 md:mb-0" data-id="element-1873">
                    <UserIcon size={16} className="mr-2 text-gray-600" data-id="element-1874" />
                    <span className="text-sm text-gray-600" data-id="element-1875">
                      Contact: {delivery.courier.contact}
                    </span>
                  </div>
                  <div className="flex space-x-3" data-id="element-1876">
                    <button className="px-4 py-2 bg-white border border-gray-300 rounded hover:bg-gray-50 text-sm flex items-center" data-id="element-1877">
                      <PackageIcon size={16} className="mr-2" data-id="element-1878" />
                      View Details
                    </button>
                    {delivery.status === 'Delivered' ? <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 text-sm flex items-center" data-id="element-1879">
                        <CheckCircleIcon size={16} className="mr-2" data-id="element-1880" />
                        Confirm Receipt
                      </button> : <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm flex items-center" data-id="element-1881">
                        <ClipboardCheckIcon size={16} className="mr-2" data-id="element-1882" />
                        Contact Courier
                      </button>}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
        {/* Delivery FAQ */}
        <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1883">
          <h2 className="text-xl font-bold mb-6" data-id="element-1884">Frequently Asked Questions</h2>
          <div className="space-y-4" data-id="element-1885">
            {[{
            question: 'How are my property documents and keys delivered securely?',
            answer: 'We partner with trusted international courier services like DHL and FedEx to ensure secure delivery of your property documents and keys. All packages are insured and require signature verification upon delivery.'
          }, {
            question: 'Can I track my delivery in real-time?',
            answer: "Yes, you can track your delivery in real-time through our platform. We integrate directly with courier tracking systems to provide you with the most up-to-date information about your package's location and status."
          }, {
            question: 'What happens if my delivery is lost or damaged?',
            answer: 'All deliveries through our platform are insured. In the rare event that a package is lost or damaged, we will work with the courier service to file a claim and arrange for replacement documents or keys as needed.'
          }, {
            question: 'How long does international delivery typically take?',
            answer: 'International delivery typically takes 3-5 business days for express services, depending on the destination country. Standard delivery may take 7-10 business days.'
          }].map((faq, index) => <div key={index} className="border-b border-gray-200 pb-4 last:border-b-0" data-id="element-1886">
                <h3 className="font-bold mb-2" data-id="element-1887">{faq.question}</h3>
                <p className="text-gray-700" data-id="element-1888">{faq.answer}</p>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};
export default TrackDelivery;